<template>
  <div class="download">
    <div class="icon first-icon">
      <span class="logo"></span>
      <!-- <img class="logo" src="../assets/img/userad.png" alt=""> -->
    </div>
    <div
      class="icon"
      @click="showService"
      v-if="homeConfig.service_switch === '1'"
    >
      <i class="iconfont">&#xe632;</i>
      <span>{{ $t("downloadTip.online_service") }}</span>
    </div>
    <div class="icon download-icon">
      <span class="downloadIcon"></span>
      <span>{{ $t("downloadTip.download") }}</span>
      <div class="erweima">
        <div class="left">
          <img
            :src="$store.state.downloadImg.qr_url"
            :alt="$t('downloadTip.qr_code')"
          />
          <p class="download-words">{{ $t("downloadTip.download_app") }}</p>
          <p class="more-game">{{ $t("downloadTip.more_live") }}</p>
        </div>
      </div>
    </div>
    <div class="icon" @click="showTip">
      <i class="iconfont">&#xe60d;</i>
      <span>{{ $t("downloadTip.cooperation") }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "download",
  computed: {
    homeConfig() {
      return this.$store.state.config;
    },
    roomServiceUrl() {
      return this.$store.state.room_service_url;
    },
  },
  watch: {
    homeConfig: {
      handler(newVal) {
        console.log(newVal);
      },
      deep: true,
    },
  },
  methods: {
    showTip() {
      this.$EventBus.$emit("hide", {
        type: "success",
        msg: this.$t("downloadTip.no_content"),
      });
    },
    showService() {
      let url = this.homeConfig.service_url;
      if (this.$route.path.split("/")[1] === "liveDetails") {
        url = this.roomServiceUrl
          ? this.roomServiceUrl
          : this.homeConfig.service_url;
      }
      window.open(url, "", "channelmode=yes,width=820,height=600");
    },
  },
};
</script>
<style scoped>
.download {
  z-index: 10;
  position: fixed;
  top: 25.6rem;
  right: 0;
  width: 8rem;
  /* height:20.7rem; */
  /* padding: 1rem; */
  /* padding-bottom: 2rem; */
  display: flex;
  flex-direction: column;
  text-align: center;
  /* background:#fff; */
  /* border-top:0.3rem solid var(--primary-color); */
  /* box-shadow: 0px 0.4rem 0.7rem 0px rgba(0, 0, 0, 0.11); */
}
.logo {
  width: 4rem;
  height: 4rem;
  margin-top: 10px;
  background-image: var(--img-userad);
  background-size: 100% 100%;
  display: inline-block;
}
.downloadIcon {
  width: 4rem;
  height: 4rem;
  margin-top: 10px;
  background-image: url(../assets/img/downloadtip.png);
  background-size: 100% 100%;
  display: inline-block;
}
.icon {
  font-size: 1.2rem;
  width: 8rem;
  height: 8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin-top:3.4rem; */
  margin-bottom: 1px;
  cursor: pointer;
  border-radius: 3px;
  color: #f3f2ef;
  background: rgba(255, 195, 22, 0.5);
}
.first-icon {
  margin-top: 0.2rem;
}
.icon:hover i {
  color: var(--primary-color);
}
.icon i {
  font-size: 4rem;
}
.icon span {
  color: #f3f2ef;
  margin-top: 0.4rem;
}
.download-icon {
  position: relative;
}
.download-icon:hover .erweima {
  display: block;
}
.erweima {
  display: none;
  width: 12rem;
  height: 12rem;
  position: absolute;
  top: -3.6rem;
  right: 4.4rem;
  color: #fff;
}
.erweima img {
  width: 6.5rem;
  height: 6.5rem;
  margin-top: 0.7rem;
  object-fit: cover;
}
.download-words {
  font-size: 1.6rem;
  font-weight: 600;
  margin-top: 0.6rem;
}
.more-game {
  color: #fefefe;
  margin-top: 0.6rem;
}
.left {
  width: 11rem;
  height: 100%;
  background: var(--primary-color);
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.11);
  border-radius: 0.3rem;
}
.left::after {
  position: absolute;
  content: "";
  border-top: 0.4rem solid transparent;
  border-bottom: 0.4rem solid transparent;
  border-left: 0.5rem solid var(--primary-color);
  right: 0.5rem;
  top: 3.7rem;
}
</style>



// WEBPACK FOOTER //
// src/base/downloadTip.vue